import config from 'garaje/config/environment';

export default function () {
  this.urlPrefix = config.apiHost;

  this.get('/a/roomba/json-api/rooms', function (schema, { queryParams }) {
    const locationId = queryParams['filter[location]'];

    return schema.rooms.where({ locationId });
  });
}
